module.exports = __webpack_public_path__ + "media/images/cus_1-d32b93918e9cdab01680b800c2aedcd4.png";